module.exports = __webpack_public_path__ + "static/media/bag.2e04667c.svg";